<div class="page-loader text-center load-more link-wrapper fullwidth" *ngIf="loadButton">
	<span><span class="loading__circle loading__circle-small"></span></span>
</div>
<section id="schedule-detail" class="component component--schedule component--schedule-detail schedule schedule-detail"  [class.page-loading]='loadButton'>
	<div id="breadcrumb" class="breadcrumb bg-color-white text-color-dark">
		<div class="wrapper">
			<div class="breadcrumb__text">
				<strong class="home-page"><a href="./">WWW</a> / </strong> 
				<a class="current-page" href="{{ breadCrumbData?.current_page?.link }}">{{ breadCrumbData.parent }} / </a>
				<a class="current-page" href="{{ breadCrumbData?.current_page?.link }}">{{ breadCrumbData?.current_page?.title }}</a>
				<span> / {{ detail?.title }}</span>
			</div>
		</div>
	</div>
	<div class="schedule-detail__wrapper">
		<div class="feature-repeater schedule-detail__header">
			<div class="wrapper">
				<div class="por">
					<div class="wrapper-840">
						<div class="schedule-detail__org small-fonts" *ngIf="detail?.convenors">
							<div class="d-flex">
								<div class="left-convenor" *ngIf="leftConvenor != ''">
									<span *ngFor="let cVal of leftConvenor" [innerHtml]="cVal.name"> </span>
								</div>
								<div class="right-convenor" *ngIf="rightConvenor != ''">
									<span *ngFor="let cVal of rightConvenor" [innerHtml]="cVal.name"> </span>
								</div>
							</div>
						</div>
						<h1 class="schedule-detail__title" [innerHtml]="detail?.title"></h1>
						<div class="schedule-detail__time small-fonts" *ngIf="content_type != 'Exhibition'">
							<span class="event_status" *ngIf="null != detail?.online">
								<span>
									<span *ngIf="'online' == detail?.online"><span class="icon icon-cloud"></span>Online session</span>
									<span *ngIf="'on-site' == detail?.online"><span class="icon icon-map-pin"></span>On-site session</span>
									<span *ngIf="'both' == detail?.online"><span class="icon icon-cloud"></span><span class="icon icon-map-pin"></span>Online & On-site session</span>
								</span>
							</span>
							<div class="schedule__tr">
								<span class="icon_wrapper"><i class="icon-clock"></i></span> <strong>{{ day }}</strong>
								<span> {{ time }}</span>
							</div>
							<span class="event_status"*ngIf="detail?.room != ''"><span class="within-circle icon icon-map-pin"></span><span>Room: </span><span class="small-fonts" [innerHtml]="detail?.room"></span></span>
						</div>
						<div class="schedule-detail__time small-fonts" *ngIf="content_type == 'Exhibition'">
							<span class="event_status" *ngIf="null != detail?.online">
								<span>
									<p *ngIf="true == detail?.online"><span class="icon icon-cloud"></span>Online</p>
									<p *ngIf="false == detail?.online"><span class="icon icon-map-pin"></span>On-site</p>
								</span>
							</span>
							<div class="schedule__tr">
								<span class="icon_wrapper"><i class="icon-clock"></i></span> <strong>{{ day }}</strong>
								<span> {{ time }}</span>
							</div>
							<div class="schedule__tr" *ngIf="detail?.room != ''">
								<span class="event_status"*ngIf="detail?.room != ''"><span class="within-circle icon icon-map-pin"></span><span>Room: </span><span class="small-fonts" [innerHtml]="detail?.room"></span></span>
							</div>
						</div>
					</div>
				</div>
				<div class="schedule-detail__image" *ngIf="detail?.image">
					<div class="wrapper wrapper-700">
						<figure>
							<img [defaultImage]="detail.image" [lazyLoad]="detail.image" class="img-responsive" alt="{{ detail?.title }}" loading="lazy" width="700" />
							<span class="img-caption" *ngIf="detail.imageCaption" [innerHtml]="detail.imageCaption | safe:'preamble'"></span>
						</figure>
					</div>
				</div>
				<div class="schedule-detail__intro page-intro" *ngIf="detail?.introduction != ''">
					<div class="wrapper wrapper-700">
						<div class="preamble" [innerHtml]="detail?.introduction | safe:'preamble'"></div>
					</div>
				</div>
			</div>
		</div>
		<!-- conclusion here -->
		<div class="feature-repeater conclusion-wrapper" *ngIf="detail?.hasConclusion == true && detail?.conclusion">
			<div class="wrapper wrapper-800">
				<div class="feature-repeater schedule-detail__conclusion conclusion">
					<div class="wrapper wrapper-700">
						<h2><i class="icon-conclusion"></i> Conclusion</h2>
						<div class="entry-content" [innerHtml]="detail.conclusion | safe:'preamble'"></div>
					</div>
				</div>
				<div class="feature-repeater schedule-detail__resources resources" *ngIf="detail.resources != ''">
					<div class="wrapper wrapper-700">
						<h2>Resources</h2>
						<div class="resources__holder">
							<div class="resources__repeater resources__{{ rVal.Type == 'Link' ? 'url' :'pdf' }}" *ngFor="let rVal of detail.resources">
								<a href="{{ rVal.Url }}" target="_blank">
									<div class="{{ rVal.Type == 'Link' ? 'url' :'pdf' }} icon" [innerHtml]="rVal.Type"></div>
									<div class="content">
										<h3 *ngIf="rVal?.Title" [innerHtml]="rVal.Title"></h3>
										<p>
											<span class="url" *ngIf="rVal.Url != '' && rVal.Type == 'Link'">{{ rVal.Url }}</span>
											<span [innerHtml]="rVal.Description"></span>
										</p>
									</div>
								</a>
							</div>
							<div class="resources__repeater resources__video" *ngIf="detail.videoLink">
								<div class="row">
									<div class="col">
										<div class="embed-responsive embed-responsive-16by9">
											<iframe width="560" height="315" [src]="video_url" frameborder="0"></iframe>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- conclusion here -->
		<div class="feature-repeater schedule-detail__content">
			<div class="wrapper wrapper-700">
				<div class="entry-content content-from-editor" *ngIf="description">
					<div class="content__details" [innerHtml]="description | safe:'preamble'"></div>
				</div>
				<ul class="tags" *ngIf="detail?.tags" [ngClass]="(detail.eventType == 'Exhibition' || detail.eventType == 'Expo')?'exhibiton-tags':''">
					<li class="btn btn-default" *ngFor="let tVal of detail_tags">
						<a href="javascript:void(0);" class="{{ tVal.class == 'activated' ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', tVal.id, tVal.name )" *ngIf="detail.eventType != 'Exhibition' && detail.eventType != 'Expo'">{{ tVal.name }}</a>
						<a href="javascript:void(0);" class="not-a-link" *ngIf="detail.eventType == 'Exhibition' || detail.eventType == 'Expo'">{{ tVal.name }}</a>
					</li>
					<li class="btn btn-default ">
						<a href="javascript:void(0);" class="{{ eventTypeClass == 'activated' ? 'activated' : '' }}" (click)="filterMore( $event, 'session', detail.eventTypeId, detail.eventType )" *ngIf="detail.eventType != 'Exhibition' && detail.eventType != 'Expo'">#{{ detail.eventType }}</a>
						<a href="javascript:void(0);" class="not-a-link" *ngIf="detail.eventType == 'Exhibition' || detail.eventType == 'Expo'">#{{ detail.eventType }}</a>
					</li>
					<li class="btn btn-default gold-btn" *ngIf="detail?.isGoldStar == true">
						<a href="javascript:void(0);" class="{{ goldClass == 'activated' ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', 5000, 'goldstandard' )" *ngIf="detail.eventType != 'Exhibition' && detail.eventType != 'Expo'"><i class="icon-star"></i> goldstandard</a>
						<a href="javascript:void(0);" class="not-a-link" *ngIf="detail.eventType == 'Exhibition' || detail.eventType == 'Expo'"><i class="icon-star"></i> goldstandard</a>
					</li>
					<li class="btn btn-default btn-open-session" *ngIf="detail?.isOpenSession == true">
						<a href="javascript:void(0);" class="{{ opensessionClass == 'activated' ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', 25000, 'opensession' )" *ngIf="detail.eventType != 'Exhibition' && detail.eventType != 'Expo'"><i class="icon-open-session"></i> Open Session</a>
					</li>
					<li class="btn social-handler" *ngFor="let thVal of twitter_name; let i = index">
						<a class="sh-twitter" target="_blank" href="https://twitter.com/hashtag/{{ thVal }}"><i class="icon-twitter"></i> {{ twitter_link[i] }}</a>
					</li>
					<li class="btn social-handler" *ngIf="detail?.facebookLink">
						<a class="sh-twitter" target="_blank" href="{{ detail.facebookLink }}"><i class="icon-facebook"></i> {{ detail.facebookLink }}</a>
					</li>
				</ul>
				<div class="goldstandard" *ngIf="detail?.isGoldStar == true">
					Gold standard events are committed to ensure the gender balance in speakers/panellists and young professional representation in the session.
				</div>
				<div class="share-wrapper">
					<strong>Share</strong>
					<div id="social-share-container" class="jssocials">
						<div class="jssocials-shares">
							<div class="jssocials-share jssocials-share-twitter">
								<a href="javascript:void(0);" (click)="popupCenter( 'https://twitter.com/share?&amp;text=World Water Week - ' + detail?.title + '&amp;url=' + current_url_slug, 'Tweet', '540', '400' )" class="jssocials-share-link"><i class="icon-twitter jssocials-share-logo"></i></a>
							</div>
							<div class="jssocials-share jssocials-share-facebook">
								<a href="javascript:void(0);" (click)="popupCenter('http://www.facebook.com/sharer.php?u=' + current_url_slug, 'Share', '620', '280' )" class="jssocials-share-link"><i class="icon-facebook jssocials-share-logo"></i></a>
							</div>
							<div class="jssocials-share jssocials-share-linkedin">
								<a href="javascript:void(0);" (click)="popupCenter( 'http://www.linkedin.com/shareArticle?mini=true&url=' + current_url_slug, 'Share', '540', '400' )" class="jssocials-share-link"><i class="icon-linkedin jssocials-share-logo"></i></a>
							</div>
							<div class="jssocials-share jssocials-share-email">
								<a target="_self" href="mailto:?subject=World Water Week - {{detail?.title}}&amp;body={{ description }}{{current_url_slug}}" class="jssocials-share-link"><i class="icon-email jssocials-share-logo"></i></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="feature-repeater schedule-detail__program program" *ngIf="detail?.programme">
			<div class="wrapper wrapper-700">
				<h2>Programme</h2>
				<div class="entry-content" [innerHtml]="detail.programme | safe:'preamble'"></div>
			</div>
		</div>
		<div class="feature-repeater schedule-detail__resources resources" *ngIf="detail?.hasConclusion == false && detail?.resources != ''">
			<div class="wrapper wrapper-700">
				<h2>Resources</h2>
				<div class="resources__holder">
					<div class="resources__repeater resources__{{ rVal.Type == 'Link' ? 'url' : 'pdf'}}" *ngFor="let rVal of detail.resources">
						<a href="{{ rVal.Url }}" target="_blank">
							<div class="{{ rVal.Type == 'Link' ? 'url' : 'pdf'}} icon">{{ rVal.Type }}</div>
							<div class="content">
								<h3 *ngIf="rVal?.Title" [innerHtml]="rVal.Title"></h3>
								<p>
									<span class="url" *ngIf="rVal.Url != '' && rVal.Type == 'Link'">{{ rVal.Url }}</span>
									{{ rVal.Description }}
								</p>
							</div>
						</a>
					</div>
					<div class="resources__repeater resources__video" *ngIf="detail.videoLink">
						<div class="row">
							<div class="col">
								<div class="embed-responsive embed-responsive-16by9">
									<iframe width="560" height="315" [src]="video_url" frameborder="0"></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="feature-repeater schedule-detail__convenors convenors">
			<div class="wrapper wrapper-700">
				<h2>Convenors</h2>
				<ul class="convenors__list" *ngIf="detail?.convenors || detail?.otherConvenor">
					<li class="convenors__repeater" *ngFor="let cVal of detail.convenors">
						<a href="javascript:void(0);" style="cursor: default;" [innerHtml]="cVal.name"></a>
					</li>
					<li class="convenors__repeater" *ngIf="null != detail.otherConvenor">
						<a href="javascript:void(0);" style="cursor: default;" [innerHtml]="detail.otherConvenor"></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</section>